import {Controller} from '@hotwired/stimulus';
import Axios from '../axios';

export default class extends Controller {

    static targets() {
        return ['list', 'filters', 'submit', 'pagination', 'clear'];
    }

    connect() {
        this.currentLanguageCode = document.documentElement.lang.split('-')[0];
        this.page = 0;
        this.type = this.element.dataset.type;
        this.filters = {};
        this.autoSubmit = false;

        this.handleFilters();
        this.pagination();

        const submitBtn = this.targets.find('submit');
        if (submitBtn) {
            submitBtn.addEventListener('click', (e) => {
                e.preventDefault();

                delete this.filters['page'];

                this.fetchPosts().then(response => {
                    if (response && response.html) {
                        this.insertContent(response);
                    }
                });
            });
        } else {
            this.autoSubmit = true;
        }

        const clearBtn = this.targets.find('clear');
        if (clearBtn) {
            this.targets.find('clear')?.addEventListener('click', (e) => {
                e.preventDefault();

                this.filters = {};
                clearBtn.classList.add('hidden');
                const postFilters = this.targets.find('filters');
                if (postFilters) {
                    postFilters.querySelectorAll('[data-is-filter]').forEach(filter => {
                        filter.value = '';
                        filter.dispatchEvent(new Event('change'));
                    });
                }
            });
        }
    }

    handleFilters() {
        const postFilters = this.targets.find('filters');
        if (postFilters) {
            postFilters.querySelectorAll('select[data-is-filter]').forEach((select) => {
                select.addEventListener('change', () => {
                    const type = select.getAttribute('data-type') ?? 'meta';
                    this.filters[select.name] = { value: Array.from(select.querySelectorAll('option:checked')).map(elm => elm.value), type: type };
                    this.targets.find('clear')?.classList.remove('hidden');
                });
            });

            postFilters.querySelectorAll('input[type="text"][data-is-filter]').forEach((input) => {
                input.addEventListener('input', () => {
                    const type = input.getAttribute('data-type') ?? 'meta';
                    this.filters[input.name] = { value: input.value, type: type };
                    this.targets.find('clear')?.classList.remove('hidden');
                });
            });

            postFilters.querySelectorAll('input[type="checkbox"][data-is-filter]').forEach((input) => {
                input.addEventListener('change', () => {
                    const type = input.getAttribute('data-type') ?? 'meta';
                    this.filters[input.name] = { value: input.value ? 1 : 0, type: type };
                    this.targets.find('clear')?.classList.remove('hidden');
                });
            });

            postFilters.querySelectorAll('button[data-is-filter]').forEach((button) => {
                button.addEventListener('click', () => {
                    const type = button.getAttribute('data-type') ?? 'meta';
                    this.filters[button.name] = { value: button.value, type: type };
                    this.targets.find('clear')?.classList.remove('hidden');
                    if (this.autoSubmit) {
                        delete this.filters['page'];

                        this.fetchPosts().then(response => {
                            if (response && response.html) {
                                this.insertContent(response);
                            }
                        });
                    }
                });
            });
        }
    }

    async fetchPosts() {
        this.element.classList.remove('loading-block-loaded');
        this.element.classList.add('loading-block');

        const data = {
            rest_language: this.currentLanguageCode,
            filters: this.filters,
        };

        let response = null;
        try {
            response = await Axios.post(`${theme.rest_route}${this.type}`, data);
            response = response.data;
        } catch (error) {
            response = error.response.data.data;
        }

        return response;
    }

    pagination() {
        const pagination = this.targets.find('pagination');
        pagination.querySelectorAll('a').forEach((a) => {
            a.addEventListener('click', (e) => {
                e.preventDefault();
                const urlParams = new URLSearchParams(new URL(a.getAttribute('href')).search);
                this.filters['page'] = urlParams.get('page') ? urlParams.get('page') : 1;

                this.fetchPosts().then(response => {
                    if (response && response.html) {
                        this.insertContent(response);
                    }
                });
            });
        });
    }

    insertContent(response) {

        const list = this.targets.find('list');
        if (list) {
            let i = 0;
            let d = 0;
            const children = Array.from(list.children);
            children.forEach((item) => {
                d = d + .1;
                i++;
                item.classList.remove('animate-insert');
                item.classList.add('animate-removal');
                item.style.setProperty("--animation-duration", d.toFixed(2) + 's');

                if (i === children.length) {
                    item.addEventListener('animationend', () => {
                        list.innerHTML = '';
                        list.insertAdjacentHTML('beforeend', response.html);
                        list.parentElement.style.scrollMarginTop = '300px';
                        list.parentElement.scrollIntoView({ behavior: 'smooth', block: 'start' });

                        const headerOffset = 200;
                        const offsetPosition = list.parentElement.getBoundingClientRect().top + (window.scrollY || window.pageYOffset) - headerOffset;
                        window.scrollTo({
                            top: offsetPosition,
                            behavior: 'smooth'
                        });

                        this.element.classList.remove('loading-block');
                        this.element.classList.add('loading-block-loaded');

                        let i2 = list.children.length;
                        let d2 = list.children.length * 0.1;
                        Array.from(list.children).forEach((item2) => {
                            d2 = d2 - .1;
                            item2.style.setProperty("--animation-duration", d2.toFixed(2) + 's');
                        });

                        Array.from(list.children).forEach((item2) => {
                            i2--;
                            item2.classList.remove('animate-render');
                            item2.classList.add('animate-insert');
                            item2.addEventListener('animationend', () => {
                                item2.classList.remove('animate-insert');
                            });
                        });
                    });
                }
            });
        }
        const pagination = this.targets.find('pagination');
        if (pagination) {
            pagination.innerHTML = response.pagination_html;
            this.pagination();
        }

        setTimeout(() => this.element.classList.remove('loading-block-loaded'), 1000);
    }
}
